import PropTypes from 'prop-types'
import classNames from 'classnames'

import { useBreakpoint } from '../../../../../hooks/breakpoint'

import Typography from '../../../typography'
import Icon from '../../../icon/index'

import Download from '../../../icon/download-full-color.svg'
import Podcast from '../../../icon/podcast-full-color.svg'
import Ebook from '../../../icon/ebooks-full-color.svg'

const Header = ({ title, text, resourceKind, ...attrs }) => {
  const breakpoint = useBreakpoint()
  const icon = resourceKind === 'download' ? Download : resourceKind === 'audio' ? Podcast : Ebook

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'pt-20',
      'pb-10',
      'md:pt-24',
      'md:pb-16',
      'md:bg-white'
    ]
  )

  return <section {...attrs}>
    <div
      className={'absolute top-0 left-0 w-full bg-green-50'}
      style={{
        height: `calc( 100% - ${breakpoint.mdAndUp ? '6rem' : '4rem'} )`
      }} />
    <div
      className={'absolute bottom-0 bg-green-50'}
      style={{
        borderRadius: '100%',
        left: '-5vw',
        width: '110vw',
        height: breakpoint.mdAndUp ? '12rem' : '8rem'
      }} />

    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames([
            'flex',
            'flex-row',
            'flex-wrap',
            '-mx-4'
          ])
        }>
        <div
          className={
            classNames([
              'relative',
              'p-4',
              'flex',
              'flex-row',
              'justify-center',
              'items-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%'
          }}>
          <div
            className={
              'md:mr-6'
            }>
            <Icon
              svg={icon}
              size={100}
              width={100}
              height={100} />
          </div>
          <div
            className={
              classNames(
                [
                  'flex',
                  'flex-col',
                  'items-center',
                  'md:items-start',
                  'md:max-w-lg'
                ]
              )
            }>
            <Typography
              tag="h1"
              size={'five'}
              weight="bold"
              className={
                classNames(
                  [
                    'text-gray-600',
                    'md:text-green-600'
                  ]
                )
              }
              style={
                {
                  fontSize: breakpoint.mdAndUp ? '4rem' : '',
                  lineHeight: breakpoint.mdAndUp ? '122%' : ''
                }
              }>
              {title}
            </Typography>
            <Typography
              tag="p"
              size="three"
              className="text-gray-500 md:mt-4">
              {text}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  </section>
}

Header.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  resourceKind: PropTypes.string
}

export default Header
